'use client'
import clsx from 'clsx'
import Link from 'next/link'
import { usePathname } from 'next/navigation'

export function NavItem({ href, children }) {
  let isActive = usePathname() === href

  return (
    <Link
      href={href}
      className={clsx(
        ' leading-none flex-shrink-0',
        isActive
          ? 'underline text-zinc-950 dark:text-zinc-100'
          : 'text-zinc-700 dark:text-zinc-400 hover:text-zinc-950 dark:text-zinc-200'
      )}
    >
      {children}
    </Link>
  )
}
